import axios from "axios";
import store from "@/store/index.js";
import { Toast } from "vant";
import { encrypt, decrypt } from "@/utils/aes.js";
//通过axios.defaults.timeout设置默认的请求超时时间。例如超过了5s，就会告知用户当前请求超时，请刷新等。
//axios.defaults.timeout = 5000
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";
//请求拦截器
let ajaxTimes = 0;
const urlList = [
  "/api/biz/Hospitalization/getIpPatient",
  "/api/biz/QueryPrinting/getCkLabResult"
];

const REG_FEE_URL = "http://183.234.14.131:8888/api/His/GetRegFee";

function matchEncryptUrl(url) {
  const u = url || "";
  return urlList.some(p => u.indexOf(p) !== -1);
}

function decAjaxTimes() {
  ajaxTimes = Math.max(0, ajaxTimes - 1);
  if (ajaxTimes === 0 && store.state.LOADING) {
    store.commit("hideLoading");
  }
}

function maybeShowRefresh(response) {
  // 保持与原逻辑一致：state==500 且 obj==null 时提示刷新
  if (
    response &&
    response.data &&
    response.data.state == 500 &&
    response.data.obj == null
  ) {
    store.commit("showRefresh");
  }
}
// axios.defaults.timeout = 5000;
axios.interceptors.request.use(config => {
  if (matchEncryptUrl(config.url)) {
    config.data = { data: encrypt(JSON.stringify(config.data)) };
  }
  if (ajaxTimes === 0) {
    store.commit("showLoading");
  }
  ajaxTimes++;
  store.commit("hideRefresh");
  return config;
}, error => {
  decAjaxTimes();
  return Promise.reject(error);
});
//响应拦截器
axios.interceptors.response.use(
  response => {
    if (
      matchEncryptUrl(response && response.config && response.config.url) &&
      response &&
      response.data &&
      response.data.obj &&
      response.data.obj.resultData
    ) {
      try {
        response.data.obj.resultData = JSON.parse(
          JSON.parse(decrypt(response.data.obj.resultData))
        );
      } catch (e) {
        // 解密失败不阻断正常返回
      }
    }
    decAjaxTimes();
    maybeShowRefresh(response);
    return response;
  },
  error => {
    decAjaxTimes();
    return Promise.reject(error);
  }
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return axios
    .get(url, { params })
    .then(response => {
      maybeShowRefresh(response);
      return response;
    })
    .catch(err => {
      store.commit("showRefresh");
      return Promise.reject(err);
    });
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return axios
    .post(url, data)
    .then(response => {
      maybeShowRefresh(response);
      return response;
    })
    .catch(err => {
      // 保持原逻辑：挂号费接口不弹 500
      if (url !== REG_FEE_URL) {
        Toast.fail("Request failed with status code 500");
      }
      return Promise.reject(err);
    });
}

/**
* 封装patch请求
* @param url
* @param data
* @returns {Promise}
*/

export function patch(url, data = {}) {
  return axios
    .patch(url, data)
    .then(response => response.data)
    .catch(err => Promise.reject(err));
}

/**
* 封装put请求
* @param url
* @param data
* @returns {Promise}
*/

export function put(url, data = {}) {
  return axios
    .put(url, data)
    .then(response => response.data)
    .catch(err => Promise.reject(err));
}


// WEBPACK FOOTER //
// ./src/request/http.js